(function () {
    'use strict';

    angular
        .module('spidwebApp')
        .factory('colorService', colorService);

    colorService.$inject = ['axiosService', 'masterdatasCache', 'envService'];

    function colorService(axiosService, masterdatasCache, envService) {

        return {
            getColors: function (locale) {
                return axiosService
                    .get(
                        envService.getOfferDatasContext() +
                            '/colors?' +
                            Object.entries({ locale })
                                .map(([key, val]) => `${key}=${val}`)
                                .join('&'),
                        {
                            withCredentials: true,
                            cache: masterdatasCache,
                            headers: {
                                Accept: 'application/json;charset=UTF-8',
                            },
                        }
                    )
                    .then(function (response) {
                        return response.data;
                    });
            }
        };

    }

})();
